module.exports = __webpack_public_path__ + "img/Inspirational Motivator.b784d854.png";